module.exports = __webpack_public_path__ + "static/img/PINGAN.d36497a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bankInfoBg/PINGAN.png
// module id = ekVP
// module chunks = 69